(function($) {
    $.widget('ca.caRadioWithText', {
        _create : function() {
            $('.ca-radio-with-text input[type=radio]').on('click', function(e) {
                e.stopPropagation();
                var val = $(this).data('value');
                $(this).siblings('input[type=hidden]').val( val );
            });
        }
    });
})(jQuery);